// extracted by mini-css-extract-plugin
export default {"root":"StartButton_root__6zlic","icon":"StartButton_icon__s6Kt4"};